import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { horarioRangoUpd } from "services/services-mia/miakey";
import { Box, FormLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";

const DIAS = [
    { cod: "LU", label: "Lu" },
    { cod: "MA", label: "Ma" },
    { cod: "MI", label: "Mi" },
    { cod: "JU", label: "Ju" },
    { cod: "VI", label: "Vi" },
    { cod: "SA", label: "Sa" },
    { cod: "DO", label: "Do" },
];

export default function DeleteModal({ updateList, horarioRango, closeModal, onSuccess }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await horarioRangoUpd({
            gateHorarioId: horarioRango.gateHorarioId,
            gateHorarioRangoId: horarioRango.gateHorarioRangoId,
            gateHorarioRangoVersion: horarioRango.gateHorarioRangoVersion,
            gateHorarioRangoEntrada: horarioRango.gateHorarioRangoEntrada,
            gateHorarioRangoSalida: horarioRango.gateHorarioRangoSalida,
            gateHorarioRangoDias: "DELETE",
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected: () => { setSelected({ status: false, row: {} }); onSuccess?.(); },
            updateList,
        };

        handleResponse(response, "Rango Horario eliminado exitosamente", functions);

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                entrada: horarioRango.gateHorarioRangoEntrada?.substring(0, 5) ?? "",
                salida: horarioRango.gateHorarioRangoSalida?.substring(0, 5) ?? "",
            }}
            onSubmit={async (_, { setSubmitting }) => {
                try {
                    await handleSubmit();
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <Box display="flex" flexDirection="column" gap="4px" width="100%">
                        <FormLabel>Días</FormLabel>
                        <ToggleButtonGroup
                            value={horarioRango.dias || []}
                            aria-label="días de la semana"
                            sx={{
                                flexWrap: "wrap",
                                gap: "6px",
                                width: "100%",
                                "& .MuiToggleButton-root": {
                                    flex: 1,
                                    padding: "8px 12px",
                                    fontSize: "0.95rem",
                                    border: "1px solid rgba(0,0,0,0.23) !important",
                                    borderRadius: "4px !important",
                                    color: "rgba(0,0,0,0.6)",
                                    cursor: "default",
                                },
                                "& .MuiToggleButton-root.Mui-selected": {
                                    backgroundColor: "#FF6D00",
                                    color: "#fff",
                                    borderColor: "#FF6D00 !important",
                                },
                            }}
                        >
                            {DIAS.map(({ cod, label }) => (
                                <ToggleButton
                                    key={cod}
                                    value={cod}
                                    aria-label={label}
                                    selected={(horarioRango.dias || []).includes(cod)}
                                    onClick={(e) => e.preventDefault()}
                                    disableRipple
                                >
                                    {label}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box display="flex" flexDirection="row" gap="20px" width="100%">
                        <FormikTextInput fullWidth name="entrada" labelText="Entrada" type="time" disabled />
                        <FormikTextInput fullWidth name="salida" labelText="Salida" type="time" disabled />
                    </Box>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
